import { BodyText } from "@/components/ui";
import type { ChatMessage } from "@/features/Chat/types/chatMessageTypes";
import { capitalize } from "@/lib/formatters";
import { formatDate } from "date-fns";

interface EncounterCloseMessageProps {
  message: ChatMessage;
}

export const EncounterCloseMessage = ({
  message,
}: EncounterCloseMessageProps) => {
  return (
    <div className="flex flex-col gap-1 justify-center items-center">
      <BodyText size="sm" textColor="primary" italic>
        Encounter closed -{" "}
        {message.incomplete
          ? capitalize(message.incompleteType as string)
          : "Completed"}
      </BodyText>
      <BodyText size="xs" textColor={"tertiary"}>
        {formatDate(new Date(message.created), "MM/dd/yyyy h:mm a")}
      </BodyText>
    </div>
  );
};
